import { useState, useEffect } from "react";
import styles from "./CookiesFooter.module.css";

// Utility to read cookies
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return decodeURIComponent(parts.pop().split(";").shift());
  return null;
};

// Utility to set cookies
const setCookie = (name, value, days = 365) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/`;
};

export const CookiesFooter = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = getCookie("cookieConsent");
    if (!consent) setShowBanner(true);
  }, []);

  const handleAcceptAll = () => {
    const allPrefs = {
      essential: true,
      functional: true,
      performance: true,
      targeting: true,
    };
    setCookie("cookieConsent", JSON.stringify(allPrefs));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Cookie Banner */}
      <div className={styles.cookiesWapper}>
        <div style={{   color: "#3a3a3a", maxWidth: "600px" }}>
          <strong>
            We use cookies to ensure you get the best user experience on our
            website.
          </strong>{" "}
          By continuing to use this site, you agree to the use of these cookies.
        </div>

        <div style={{ display: "flex", gap: "1rem" }}>
          <button
            style={{
              background: "var(--green)",
              color: "white",
              padding: "8px 16px",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={handleAcceptAll}
          >
            ACCEPT ALL COOKIES
          </button>
        </div>
      </div>
    </>
  );
};
